<script>
import { Pagination } from 'ant-design-vue';

export default {
  emits: ['stateChange'],
  components: { Pagination },
  props: {
    total: {
      type: Number,
      default: 10,
    },
    pageSizeOptions: {
      type: Array,
      default: () => ['10', '20', '50'],
    },
    size: {
      type: String,
      default: 'medium',
    },
    defaultPageNo: {
      type: Number,
      default: 1,
    },
    defaultPageSize: {
      type: Number,
      default: 10,
    },
    allowSizeChange: {
      type: Boolean,
      default: true,
    },
    simple: {
      type: Boolean,
      default: false,
    },
    hideOnSinglePage: {
      type: Boolean,
      default: false,
    },
    showSizeChanger: {
      type: Boolean,
      default: true,
    },
    current: {
      type: Number,
      default: undefined,
    },
  },
};
</script>

<template>
  <div>
    <Pagination
      :hideOnSinglePage="hideOnSinglePage"
      :pageSizeOptions="pageSizeOptions"
      :total="total"
      :responsive="true"
      :showTitle="true"
      :current="defaultPageNo"
      :defaultCurrent="defaultPageNo"
      :defaultPageSize="defaultPageSize"
      :show-size-changer="allowSizeChange"
      :size="size"
      :simple="simple"
      @change="(pageNo, pageSize) => $emit('stateChange', { pageNo, pageSize })"
      :showSizeChanger="showSizeChanger"
    />
  </div>
</template>

<style lang="scss" scoped></style>
